import { twMerge } from 'tailwind-merge';

interface ProgressBarProps {
  progress: number;
  total?: number;
  classNames?: {
    root?: string;
    slide?: string;
  };
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  total = 100,
  classNames,
}) => {
  const progressWidth = (progress / total) * 100;
  const progressBarStyle = {
    width: `${progressWidth}%`,
    transition: 'width 0.3s ease, transform 0.3s ease',
  };

  return (
    <div
      className={twMerge(
        `h-1 w-full rounded-lg bg-gray-100`,
        classNames?.root
      )}>
      <div
        className={twMerge(`h-full rounded-lg bg-fig`, classNames?.slide)}
        style={progressBarStyle}
      />
    </div>
  );
};

export default ProgressBar;
